<!--
  Aviso de que se envió el mail de confirmación de activación del Conversor. Lo abre `mediaHardwareInspector.service.ts`
  después de que el usuario acepta contratar el conversor en MediaHardwareFeedbackModal.vue.
-->
<script lang="ts" setup>
import PolyButton from '@/components/poly/PolyButton.vue';

const props = defineProps<{
  resolve: (value: void) => void
}>()

const email = window.profile.email
</script>
<template lang="pug">
.mediaHardwareConfirmation.pmx-col
  i.fa-solid.fa-envelope-circle-check.icon
  strong.title {{ $t('Para activar el Conversor, confirma la acción desde tu mail.') }}
  span
    | {{ $t('Hemos enviado un email para confirmar la acción a la dirección') }} {{ ' ' }}
    strong {{ email }}
    | . {{ $t('En caso de no recibirlo revisa tu bandeja de Correo No Deseado o ponte en contacto con Soporte.') }}
  .pmx-row.actions
    PolyButton(@click="resolve()" data-testid="media-hardware-confirmation-aceptar-boton") {{ $t('Aceptar') }}
</template>
<style lang="less" scoped>
@import '../frontend/mobile/themevars.less';

.mediaHardwareConfirmation {
  background-color: white;
  align-items: center;
  text-align: center;
  gap: 1em;
  padding: 1.5em 2em;
  max-width: 26.25em;
  border-radius: 0.923em;

  .icon {
    font-size: 5.25em;
    color: @emphasis;
  }

  .title {
    font-size: 1.05rem;
  }

  .actions {
    width: 100%;
    justify-content: center;
  }
}
</style>
